<div class="flex gap-5 flex-1 justify-start">
  <div>
    <rk-image-upload
      (fileSelected)="onRawImageSelected($event)"
      [deleteButton]="false"
      [width]="'200px'"
      [aspectRatio]="'1/1'"
      [compactLayout]="true"
    ></rk-image-upload>
  </div>
  <div class="max-w-[436px]">
    <div class="font-bold text-lg mb-[10px]">
      {{ 'assets.splashscreens' | translate }}
    </div>
    <div class="mb-4">
      {{ 'assets.splashscreens-explained' | translate }}
    </div>
    <rk-infobox [type]="'info'" class="w-fit">
      <div class="font-bold text-sm">
        <fa-icon [icon]="'info-circle'"></fa-icon>
        {{ 'assets.restrictions' | translate }}
      </div>
      <div [innerHTML]="'assets.splashscreens-size' | translate"></div>
    </rk-infobox>
  </div>
</div>
